export const colors = {
  main: {
    red: "#ED1C24",
    blue: "#293876",
    yellow: "#FFF200",
  },
  // Navy scale derived from the brand blue (#293876)
  navy: {
    950: "#10173A",
    900: "#161F4C",
    800: "#1E2A5E",
    700: "#293876",
    600: "#37478E",
    500: "#4A5BA6",
    100: "#E3E7F3",
    50: "#F3F5FA",
  },
  // Cool neutral scale for text, borders and surfaces
  slate: {
    900: "#171D2B",
    700: "#333C4E",
    500: "#5A6474",
    400: "#828C9D",
    300: "#C3CAD6",
    200: "#E2E6EC",
    100: "#EEF1F5",
    50: "#F7F8FA",
  },
  // Yellow tuned for hover feedback (brand yellow stays the base)
  yellowDeep: "#F5E600",
  success: "#1D7C4D",
  successBg: "#E8F5EE",
  danger: "#C9161D",
  dangerBg: "#FCEBEC",
  fontBlue: "#222F3E",
  grey: "#4D4D4D",
  black: "#000000",
  white: "#FFFFFF",
  pageBg: "#F7F8FA",
};

export const font = {
  main: "15px",
  sub: "13px",
  small: "13px",
  title: "19px",
  big: "26px",
  display: "clamp(34px, 5vw, 52px)",
  h2: "clamp(26px, 3.2vw, 34px)",
  body: "'Public Sans', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
  heading: "'Archivo', 'Public Sans', 'Segoe UI', sans-serif",
};

export const radii = {
  sm: "8px",
  md: "12px",
  lg: "16px",
  xl: "24px",
  pill: "100px",
};

export const shadow = {
  xs: "0 1px 2px rgba(23, 29, 43, 0.05)",
  sm: "0 1px 3px rgba(23, 29, 43, 0.06), 0 4px 12px rgba(23, 29, 43, 0.05)",
  md: "0 2px 6px rgba(23, 29, 43, 0.06), 0 12px 28px rgba(23, 29, 43, 0.09)",
  lg: "0 4px 10px rgba(23, 29, 43, 0.08), 0 24px 48px rgba(23, 29, 43, 0.14)",
  focus: "0 0 0 3px rgba(41, 56, 118, 0.28)",
};

export const transition = {
  fast: "0.16s cubic-bezier(0.4, 0, 0.2, 1)",
  base: "0.24s cubic-bezier(0.4, 0, 0.2, 1)",
  slow: "0.4s cubic-bezier(0.4, 0, 0.2, 1)",
};

export const layout = {
  maxWidth: "1200px",
  sectionGap: "clamp(56px, 8vw, 104px)",
};
